import { render, staticRenderFns } from "./WorkerTransactionReport.vue?vue&type=template&id=d2328dfe&scoped=true"
import script from "./WorkerTransactionReport.vue?vue&type=script&lang=js"
export * from "./WorkerTransactionReport.vue?vue&type=script&lang=js"
import style0 from "./WorkerTransactionReport.vue?vue&type=style&index=0&id=d2328dfe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2328dfe",
  null
  
)

export default component.exports